module.exports = __webpack_public_path__ + "img/gas_old.be9f838d.png";